(function() {
  if (window.location.search.indexOf('adjust') === -1) return;

  var hero = document.querySelector('.hero');
  var holaImg = document.querySelector('.hero-hola-img');
  if (!hero || !holaImg) return;

  // Inject styles
  var style = document.createElement('style');
  style.textContent = [
    '.dbg-hero-wrap {',
    '  position: absolute; cursor: grab; user-select: none;',
    '  outline: 2px dashed #ff0; outline-offset: 2px;',
    '  z-index: 20;',
    '}',
    '.dbg-hero-handle {',
    '  position: absolute; width: 22px; height: 22px;',
    '  background: #ff0; border: 3px solid #000;',
    '  z-index: 10002; box-shadow: 0 0 8px rgba(0,0,0,0.6);',
    '  pointer-events: auto;',
    '}',
    '.dbg-hero-handle-tl { top: -11px; left: -11px; cursor: nwse-resize; }',
    '.dbg-hero-handle-tr { top: -11px; right: -11px; cursor: nesw-resize; }',
    '.dbg-hero-handle-bl { bottom: -11px; left: -11px; cursor: nesw-resize; }',
    '.dbg-hero-handle-br { bottom: -11px; right: -11px; cursor: nwse-resize; }',
    '.dbg-hero-label {',
    '  position: absolute; bottom: 100%; left: 50%; transform: translateX(-50%);',
    '  margin-bottom: 8px;',
    '  font: bold 12px monospace; color: #ff0; background: rgba(0,0,0,0.85);',
    '  padding: 4px 10px; border-radius: 4px; white-space: nowrap;',
    '  pointer-events: none; z-index: 10002;',
    '}',
    '.dbg-hero-export {',
    '  position: fixed; bottom: 20px; right: 20px; z-index: 99999;',
    '  background: #ff0; color: #000; border: none; padding: 14px 28px;',
    '  font: bold 15px monospace; border-radius: 8px; cursor: pointer;',
    '  box-shadow: 0 4px 14px rgba(0,0,0,0.4);',
    '}',
    '.dbg-hero-export:hover { background: #ee0; }',
  ].join('\n');
  document.head.appendChild(style);

  // Wrap holaImg in a draggable div
  var wrap = document.createElement('div');
  wrap.className = 'dbg-hero-wrap';

  // Get current position relative to hero
  var heroRect = hero.getBoundingClientRect();
  var imgRect = holaImg.getBoundingClientRect();

  wrap.style.left = ((imgRect.left - heroRect.left) / heroRect.width * 100) + '%';
  wrap.style.top = ((imgRect.top - heroRect.top) / heroRect.height * 100) + '%';
  wrap.style.width = (imgRect.width / heroRect.width * 100) + '%';

  holaImg.parentNode.insertBefore(wrap, holaImg);
  wrap.appendChild(holaImg);

  holaImg.style.position = 'relative';
  holaImg.style.width = '100%';
  holaImg.style.height = 'auto';
  holaImg.style.display = 'block';
  holaImg.style.top = 'auto';
  holaImg.style.left = 'auto';

  // Add handles
  ['tl','tr','bl','br'].forEach(function(c) {
    var h = document.createElement('div');
    h.className = 'dbg-hero-handle dbg-hero-handle-' + c;
    h.dataset.corner = c;
    wrap.appendChild(h);
  });

  // Add label
  var label = document.createElement('div');
  label.className = 'dbg-hero-label';
  wrap.appendChild(label);

  // Drag & resize
  var dragging = false;
  var resizing = null;
  var dragStart = {};

  wrap.addEventListener('mousedown', function(e) {
    if (e.target.classList.contains('dbg-hero-handle')) return;
    e.preventDefault();
    dragging = true;
    wrap.style.cursor = 'grabbing';
    var hr = hero.getBoundingClientRect();
    var wr = wrap.getBoundingClientRect();
    dragStart = {
      mx: e.clientX, my: e.clientY,
      left: wr.left - hr.left,
      top: wr.top - hr.top
    };
  });

  wrap.querySelectorAll('.dbg-hero-handle').forEach(function(h) {
    h.addEventListener('mousedown', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var wr = wrap.getBoundingClientRect();
      var hr = hero.getBoundingClientRect();
      resizing = {
        corner: h.dataset.corner,
        startX: e.clientX,
        startW: wr.width,
        startH: wr.height,
        startLeft: wr.left - hr.left,
        startTop: wr.top - hr.top,
        aspect: wr.width / wr.height
      };
    });
  });

  document.addEventListener('mousemove', function(e) {
    var hr = hero.getBoundingClientRect();

    if (dragging) {
      e.preventDefault();
      var dx = e.clientX - dragStart.mx;
      var dy = e.clientY - dragStart.my;
      wrap.style.left = ((dragStart.left + dx) / hr.width * 100) + '%';
      wrap.style.top = ((dragStart.top + dy) / hr.height * 100) + '%';
      updateLabel();
    }

    if (resizing) {
      e.preventDefault();
      var r = resizing;
      var dx = e.clientX - r.startX;
      var newW, newLeft, newTop;

      if (r.corner === 'br') {
        newW = r.startW + dx; newLeft = r.startLeft; newTop = r.startTop;
      } else if (r.corner === 'bl') {
        newW = r.startW - dx; newLeft = r.startLeft + dx; newTop = r.startTop;
      } else if (r.corner === 'tr') {
        newW = r.startW + dx;
        var newH = newW / r.aspect;
        newLeft = r.startLeft; newTop = r.startTop - (newH - r.startH);
      } else if (r.corner === 'tl') {
        newW = r.startW - dx;
        var newH2 = newW / r.aspect;
        newLeft = r.startLeft + (r.startW - newW);
        newTop = r.startTop - (newH2 - r.startH);
      }

      if (newW < 40) newW = 40;
      wrap.style.width = (newW / hr.width * 100) + '%';
      wrap.style.left = (newLeft / hr.width * 100) + '%';
      wrap.style.top = (newTop / hr.height * 100) + '%';
      wrap.style.height = 'auto';
      updateLabel();
    }
  });

  document.addEventListener('mouseup', function() {
    if (dragging) wrap.style.cursor = 'grab';
    dragging = false;
    resizing = null;
  });

  function updateLabel() {
    var hr = hero.getBoundingClientRect();
    var wr = wrap.getBoundingClientRect();
    var l = ((wr.left - hr.left) / hr.width * 100).toFixed(1);
    var t = ((wr.top - hr.top) / hr.height * 100).toFixed(1);
    var w = (wr.width / hr.width * 100).toFixed(1);
    label.textContent = 'W:' + w + '% | L:' + l + '% T:' + t + '%';
  }

  // Export button
  var exportBtn = document.createElement('button');
  exportBtn.className = 'dbg-hero-export';
  exportBtn.textContent = 'EXPORT HERO POSITIONS';
  document.body.appendChild(exportBtn);

  exportBtn.addEventListener('click', function() {
    var hr = hero.getBoundingClientRect();
    var wr = wrap.getBoundingClientRect();
    var l = ((wr.left - hr.left) / hr.width * 100).toFixed(1);
    var t = ((wr.top - hr.top) / hr.height * 100).toFixed(1);
    var w = (wr.width / hr.width * 100).toFixed(1);

    var output = '/* HERO HOLA IMAGE POSITION */\n';
    output += '.hero-hola-img {\n';
    output += '  width: ' + w + 'vw; /* at 100vw viewport */\n';
    output += '  /* position: absolute; left: ' + l + '%; top: ' + t + '%; */\n';
    output += '}\n';
    output += '.hero-content {\n';
    output += '  padding-left: ' + l + 'vw;\n';
    output += '  padding-top: ' + t + 'vh;\n';
    output += '}\n';

    navigator.clipboard.writeText(output).then(function() {
      exportBtn.textContent = 'COPIED!';
      exportBtn.style.background = '#0f0';
      setTimeout(function() {
        exportBtn.textContent = 'EXPORT HERO POSITIONS';
        exportBtn.style.background = '#ff0';
      }, 2000);
    });
    console.log(output);
  });

  setTimeout(updateLabel, 500);
})();
